import { useEffect, useRef } from 'react';

const STORAGE_KEY = 'theme';
const STYLE_ID = '__disable_theme_transitions__';
const THEMES = ['light', 'dark'];

const isTheme = (value) => THEMES.includes(value);

function getStoredTheme() {
  try {
    return localStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}

function setStoredTheme(theme) {
  try {
    localStorage.setItem(STORAGE_KEY, theme);
  } catch {
    return;
  }
}

function applyTheme(theme) {
  document.documentElement.style.colorScheme = theme;
}

function disableTransitions() {
  if (document.getElementById(STYLE_ID)) return;

  const style = document.createElement('style');
  style.id = STYLE_ID;
  style.textContent = '*{transition:none!important}';
  document.head.appendChild(style);
}

function enableTransitions() {
  document.getElementById(STYLE_ID)?.remove();
}

export function initColorTheme(defaultTheme = 'light') {
  const saved = getStoredTheme();
  applyTheme(isTheme(saved) ? saved : defaultTheme);
}

export function useThemeToggle() {
  const rafRef = useRef(0);

  useEffect(
    () => () => {
      cancelAnimationFrame(rafRef.current);
      enableTransitions();
    },
    [],
  );

  const toggleTheme = () => {
    const next =
      document.documentElement.style.colorScheme === 'dark' ? 'light' : 'dark';

    disableTransitions();
    applyTheme(next);
    setStoredTheme(next);

    cancelAnimationFrame(rafRef.current);
    rafRef.current = requestAnimationFrame(enableTransitions);
  };

  return { toggleTheme };
}
